import { Injectable } from '@angular/core';
import {
  GlobalFilterPersistence,
  GlobalFiltersJobsitePerCustomer,
  GlobalFiltersProductLinesPerCustomer,
  ActiveProductLinesIds,
} from 'app/shared/global-filters/models/global-filters.interface';
import { getLocalStorageItem, setLocalStorageItem } from '../../../vanilla/utils/safe-storage';

export const GLOBAL_FILTERS_KEY_JOBSITE = 'ordersnprductsglobalfiltersjobsites';
export const GLOBAL_FILTERS_KEY_PRODUCTLINES = 'ordersnprductsglobalfiltersproductlines';
export const GLOBAL_FILTERS_KEY_ACTIVE_PRODUCTLINES = 'ordersnprductsglobalfiltersactiveproductlines';

@Injectable({
  providedIn: 'root',
})
export class GlobalFiltersPersistenceService {
  constructor() {}

  saveJobsiteSelection(legalEntityId: number, selectedJobsiteId: number) {
    const filtersPerCustomer = this.getJobistePersistence() || {};
    filtersPerCustomer[legalEntityId] = selectedJobsiteId;
    this.setJobsitesPersistence(filtersPerCustomer);
  }

  saveProductLinesSelection(legalEntityId: number, selectedProductLinesIds: number[]) {
    const filtersPerCustomer = this.getProductLinesPersistence() || {};
    filtersPerCustomer[legalEntityId] = selectedProductLinesIds;
    this.setProductLinesPersistence(filtersPerCustomer);
  }

  saveActiveProductLines(jobsiteId: number, productLinesIds: number[]) {
    const filtersPerJobsite = this.getActiveProductLinesPersistence() || {};

    filtersPerJobsite[jobsiteId] = productLinesIds;
    this.setActiveProductLinesPersistence(filtersPerJobsite);
  }

  getCustomerFiltersPersistence(legalEntityId: number): GlobalFilterPersistence {
    try {
      const filters: GlobalFilterPersistence = {
        activeProductLinesIds: this.getActiveProductLinesPersistence() || null,
        selectedJobsiteId: this.getJobistePersistence()[legalEntityId] || null,
        selectedProductLinesIds: this.getProductLinesPersistence()[legalEntityId] || null,
      };
      return filters;
    } catch (error) {
      return null;
    }
  }

  private getJobistePersistence(): GlobalFiltersJobsitePerCustomer {
    const rawFilters = getLocalStorageItem(GLOBAL_FILTERS_KEY_JOBSITE);
    try {
      return JSON.parse(rawFilters) as GlobalFiltersJobsitePerCustomer;
    } catch (error) {
      return {};
    }
  }

  private getProductLinesPersistence(): GlobalFiltersProductLinesPerCustomer {
    const rawFilters = getLocalStorageItem(GLOBAL_FILTERS_KEY_PRODUCTLINES);
    try {
      return JSON.parse(rawFilters) as GlobalFiltersProductLinesPerCustomer;
    } catch (error) {
      return {};
    }
  }

  private getActiveProductLinesPersistence(): ActiveProductLinesIds {
    const rawFilters = getLocalStorageItem(GLOBAL_FILTERS_KEY_ACTIVE_PRODUCTLINES);
    try {
      return JSON.parse(rawFilters) as ActiveProductLinesIds;
    } catch (error) {
      return {};
    }
  }

  private setJobsitesPersistence(filtersPerCustomer: GlobalFiltersJobsitePerCustomer) {
    setLocalStorageItem(GLOBAL_FILTERS_KEY_JOBSITE, JSON.stringify(filtersPerCustomer));
  }

  private setProductLinesPersistence(filtersPerCustomer: GlobalFiltersProductLinesPerCustomer) {
    setLocalStorageItem(GLOBAL_FILTERS_KEY_PRODUCTLINES, JSON.stringify(filtersPerCustomer));
  }

  private setActiveProductLinesPersistence(filtersPerJobsite: ActiveProductLinesIds) {
    setLocalStorageItem(GLOBAL_FILTERS_KEY_ACTIVE_PRODUCTLINES, JSON.stringify(filtersPerJobsite));
  }
}
